<template>
  <div class="base-phone-list-controls">
    <button type="button" class="base-phone-list-controls__sort" aria-haspopup="dialog" @click="$emit('sort')">
      <BaseIcon name="list" aria-hidden="true" />
      {{ $t('table.phone-list.sort') }}
    </button>
    <BaseRoundButton
      v-if="selectable"
      :size="36"
      :icon="selecting ? 'x' : 'check-square'"
      is-white
      :is-light="selecting"
      :aria-label="selecting ? $t('actions.cancel') : $t('table.phone-list.select')"
      :aria-pressed="String(selecting)"
      @click.native="$emit('update:selecting', !selecting)"
    />
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';

// The phone list's sort and select buttons, beside the result count.
export default {
  name: 'BasePhoneListControls',
  components: { BaseIcon, BaseRoundButton },
  props: {
    // Whether the list has bulk actions to select rows for.
    selectable: {
      type: Boolean,
      default: true,
    },
    selecting: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.base-phone-list-controls {
  display: flex;
  gap: 8px;

  &__sort {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    padding: 0 14px;
    border: 1px solid $color-border;
    border-radius: $radius-full;
    background: $color-white;
    font-size: 14px;
    font-weight: 500;
    color: $color-text-body;

    .base-icon {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
